export default __webpack_public_path__ + "static/media/upload_task.29faf309.svg";